import { useMemo } from 'react';
import { store }   from 'index';
import { words }   from 'utils/dictionary';


const useExpirationText = () => {

  const state    = store.getState();
  const userInfo = state.data.userInfo;
  const lang     = state.components.lang;


  const expirationText = useMemo(() => {

    const arr = [
     `${ userInfo.userName }`,
     `${ words['expirationText1'][lang] }`,
     `${ words['expirationText2'][lang] }`
    ]

    if ( !!userInfo.semelMosad.length ) {
     arr.splice(1, 0, `${ words['semelMosad'][lang] }: ${ userInfo.semelMosad }`)
    }
    return arr

   },[userInfo, lang])

   return expirationText

}


export default useExpirationText
